import { render, staticRenderFns } from "./CriterioImportCustomers.vue?vue&type=template&id=2cf2b247"
import script from "./CriterioImportCustomers.vue?vue&type=script&lang=js"
export * from "./CriterioImportCustomers.vue?vue&type=script&lang=js"
import style0 from "./CriterioImportCustomers.vue?vue&type=style&index=0&id=2cf2b247&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports